



















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ModalFooter extends Vue {
  @Prop(Boolean)
  readonly okLoading?: boolean

  @Prop({ type: String, default: 'Сохранить' })
  readonly okText?: string

  @Prop({ type: String, default: 'Отмена' })
  readonly cancelText?: string

  @Prop({ type: String, default: 'Удалить' })
  readonly removeText?: string

  @Prop(Boolean)
  readonly removeButton?: boolean

  onOk() {
    this.$emit('ok')
  }

  onCancel() {
    this.$emit('cancel')
  }

  onRemove() {
    this.$emit('remove')
  }
}
